import React, { Component } from "react";
import { Col, Row } from "react-flexbox-grid";
import { BarChart, Card, Loader, PieChart } from "ui-kit-ck-consultant";
import moment from "moment";

import { months } from "../../../utils/general";

export class Statistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      conformeBar: [],
      conformeLine: [],
      nonConformeBar: [],
      nonConformeLine: [],
      labelsExpert: [],
      consigneDataPie: [],
    };
  }

  setDataBar = () => {
    let conformeBar = [];
    let nonConformeBar = [];
    let ncBar = [];
    let labelsExpert = [];
    let colorsExpert = [];
    let totalByExpert = [];
    if (this.props.data && this.props.data.length > 0) {
      this.props.data.map((element) => {
        let index = labelsExpert.findIndex((el) => el === element.name);
        if (index === -1) {
          index = labelsExpert.length;
          labelsExpert.push(element.name);
          colorsExpert.push(element.color);
          conformeBar.push(0);
          nonConformeBar.push(0);
          ncBar.push(0);
        }
        if (element.value === 1) {
          conformeBar[index]++;
        } else if (element.value === 2) {
          ncBar[index]++;
        } else {
          nonConformeBar[index]++;
        }
        return element;
      });
    }
    labelsExpert.map((element, idx) =>
      totalByExpert.push(conformeBar[idx] + nonConformeBar[idx] + ncBar[idx])
    );
    return {
      conformeBar,
      nonConformeBar,
      ncBar,
      labelsExpert,
      totalByExpert,
      colorsExpert,
    };
  };

  getMonthKeys = () => {
    const keys = [];
    const end = moment(this.props.dateEnd);
    for (
      let month = moment(this.props.dateStart).startOf("month");
      month.isSameOrBefore(end, "month");
      month.add(1, "month")
    ) {
      keys.push(month.format("YYYY-MM"));
    }
    return keys;
  };

  setDataLine = (monthKeys) => {
    let conformeLine = [];
    let nonConformeLine = [];
    let ncLine = [];
    if (this.props.data && this.props.data.length > 0) {
      this.props.data.map((element) => {
        const month = monthKeys.indexOf(element.date.slice(0, 7));
        if (month === -1) return element;
        const line =
          element.value === 1
            ? conformeLine
            : element.value === 2
            ? ncLine
            : nonConformeLine;
        line[month] = line[month] ? line[month] + 1 : 1;
        return element;
      });
    }
    return { conformeLine, nonConformeLine, ncLine };
  };

  setDataPie = (labelsExpert, totalByExpert, colorsExpert) => {
    let consigneDataPie = [];
    if (this.props.data && this.props.data.length > 0) {
      let total = this.props.data.length;
      labelsExpert.map((element, idx) =>
        consigneDataPie.push({
          data: totalByExpert[idx]
            ? ((totalByExpert[idx] * 100) / total).toFixed(2)
            : 0,
          labels: element,
          color: colorsExpert[idx],
        })
      );
    }
    return { consigneDataPie };
  };

  setDataLineIndicator = (colorsExpert, monthKeys) => {
    let indicators = [];
    let indicatorsLabels = [];
    if (this.props.data && this.props.data.length > 0) {
      this.props.data.map((element) => {
        const month = monthKeys.indexOf(element.date.slice(0, 7));
        if (month === -1) return element;
        if (!indicatorsLabels.includes(element.indicateur)) {
          indicators.push(Array(monthKeys.length).fill(null));
          indicators[indicatorsLabels.length][month] = 1;
          indicatorsLabels.push(element.indicateur);
        } else {
          const index = indicatorsLabels.findIndex(
            (el) => el === element.indicateur
          );
          if (index !== -1) {
            indicators[index][month]++;
          }
        }
        return element;
      });
    }
    let dataIndicator = [];
    indicatorsLabels.map((element, idx) =>
      dataIndicator.push({
        label: `Indicateur nº${element}`,
        type: "line",
        data: indicators[idx],
        color: colorsExpert[idx],
      })
    );
    return { dataIndicator };
  };

  render() {
    const {
      conformeBar,
      nonConformeBar,
      ncBar,
      labelsExpert,
      totalByExpert,
      colorsExpert,
    } = this.setDataBar();
    const monthKeys = this.getMonthKeys();
    const monthLabels = monthKeys.map(
      (key) => `${months[Number(key.slice(5)) - 1]} ${key.slice(0, 4)}`
    );
    const { conformeLine, nonConformeLine, ncLine } =
      this.setDataLine(monthKeys);
    const { consigneDataPie } = this.setDataPie(
      labelsExpert,
      totalByExpert,
      colorsExpert
    );
    const { dataIndicator } = this.setDataLineIndicator(
      colorsExpert,
      monthKeys
    );
    return (
      <Card className={"mt-30 mb-30"} title={"Graphiques"}>
        {this.props.filters}
        <Row>
          {conformeBar && nonConformeBar ? (
            <Col className={"mt-10"} md={6} xs={12}>
              <BarChart
                title={"Total consigne par expert"}
                digits={0}
                isLegend={true}
                labels={labelsExpert && labelsExpert}
                xAxes={[
                  {
                    stacked: true,
                  },
                ]}
                yAxes={[
                  {
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  },
                ]}
                dataSet={[
                  {
                    type: "bar",
                    label: "Conforme",
                    data: conformeBar,
                    color: "green",
                  },
                  {
                    type: "bar",
                    label: "Non conforme",
                    data: nonConformeBar,
                    color: "red",
                  },
                  {
                    type: "bar",
                    label: "N.C",
                    data: ncBar,
                    color: "gray",
                  },
                ]}
              />
            </Col>
          ) : null}
          {conformeLine && nonConformeLine ? (
            <Col className={"mt-10"} md={6} xs={12}>
              <BarChart
                title={"Nombre de consignes par mois"}
                digits={0}
                isLegend={true}
                labels={monthLabels}
                dataSet={[
                  {
                    type: "bar",
                    label: "Conforme",
                    data: conformeLine,
                    color: "green",
                  },
                  {
                    type: "bar",
                    label: "Non conforme",
                    data: nonConformeLine,
                    color: "red",
                  },
                  {
                    type: "bar",
                    label: "N.C",
                    data: ncLine,
                    color: "gray",
                  },
                  {
                    type: "line",
                    label: "Conforme (%)",
                    data: conformeLine.map(
                      (element, idx) =>
                        (element * 100) /
                        ((element || 0) + (nonConformeLine[idx] || 0))
                    ),
                    color: "#bcf5d5",
                  },
                  {
                    type: "line",
                    label: "Non conforme (%)",
                    data: nonConformeLine.map(
                      (element, idx) =>
                        (element * 100) /
                        ((element || 0) + (conformeLine[idx] || 0))
                    ),
                    color: "#ffb8b8",
                  },
                ]}
              />
            </Col>
          ) : null}
          {consigneDataPie ? (
            <Col className={"mt-10"} md={6} xs={12}>
              <PieChart
                title={"Taux de consignes par expert"}
                format="percentage"
                legendDisplay={true}
                height={250}
                data={consigneDataPie && consigneDataPie}
              />
            </Col>
          ) : null}
          {dataIndicator ? (
            <Col className={"mt-10"} md={6} xs={12}>
              <BarChart
                title={"Nombre de consignes par mois par indicateur"}
                digits={0}
                isLegend={true}
                labels={monthLabels}
                dataSet={dataIndicator.length > 0 && dataIndicator}
              />
            </Col>
          ) : null}
        </Row>
        <Loader show={this.props.loader} />
      </Card>
    );
  }
}

export default Statistics;
